module.exports = __webpack_public_path__ + "img/green.68cd315c.svg";